import { render } from "./LC_procedure.vue?vue&type=template&id=2e993e6a&scoped=true"
import script from "./LC_procedure.vue?vue&type=script&lang=js"
export * from "./LC_procedure.vue?vue&type=script&lang=js"

import "./LC_procedure.vue?vue&type=style&index=0&id=2e993e6a&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e993e6a"]])

export default __exports__